import { render, staticRenderFns } from "./ClientProfileBills.vue?vue&type=template&id=7151eae6&scoped=true&"
import script from "./ClientProfileBills.vue?vue&type=script&lang=js&"
export * from "./ClientProfileBills.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileBills.vue?vue&type=style&index=0&id=7151eae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7151eae6",
  null
  
)

export default component.exports